(function () {
  const LOG_PREFIX = '[site-selector-popup]';

  function log() {
    const args = Array.prototype.slice.call(arguments);
    console.log.apply(console, [LOG_PREFIX].concat(args));
  }

  function warn() {
    const args = Array.prototype.slice.call(arguments);
    console.warn.apply(console, [LOG_PREFIX].concat(args));
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, hours, domain) {
    const maxAge = Math.round(hours * 60 * 60);
    let cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + maxAge + '; path=/; samesite=Lax';
    if (domain) cookie += '; domain=' + domain;
    if (window.location.protocol === 'https:') cookie += '; secure';

    log('Writing cookie:', cookie);
    document.cookie = cookie;

    const verify = getCookie(name);
    if (verify === value) {
      log('Cookie write verified OK for "' + name + '".');
    } else {
      warn(
        'Cookie write FAILED to verify for "' + name + '". Expected value "' + value + '", got "' + verify + '".',
        domain
          ? 'Check that domain="' + domain + '" matches the current host (' + window.location.hostname + ') - browsers silently reject a domain attribute that does not match.'
          : 'No domain attribute was set - this should always work unless cookies are blocked entirely.'
      );
    }
    return verify === value;
  }

  function resolveCookieDomain(root) {
    if (!root) {
      log('No cookie root domain configured - using a host-only cookie.');
      return undefined;
    }
    const host = window.location.hostname;
    if (host === root || host.endsWith('.' + root)) {
      const domain = '.' + root;
      log('Host "' + host + '" matches configured root "' + root + '" - scoping cookie to "' + domain + '".');
      return domain;
    }
    log(
      'Host "' + host + '" does not match configured root "' + root + '" (likely a preview/dev domain) - using a host-only cookie instead of scoping to "' + root + '".'
    );
    return undefined;
  }

  function readState(cookieName) {
    const raw = getCookie(cookieName);
    log('Raw cookie "' + cookieName + '":', raw === null ? '(not set)' : raw);
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      log('Parsed cookie state:', parsed);
      return parsed;
    } catch (error) {
      warn('Failed to parse cookie "' + cookieName + '" as JSON:', raw, error);
      return null;
    }
  }

  function init(modal) {
    log('init() called for modal:', modal.id || modal);

    if (modal.dataset.siteSelectorInitialized) {
      log('Modal already initialized - skipping.');
      return;
    }
    modal.dataset.siteSelectorInitialized = 'true';

    const cookieName = modal.getAttribute('data-cookie-name') || 'dalton_site_selector';
    const cookieRoot = modal.getAttribute('data-cookie-domain') || '';
    const cookieDomain = resolveCookieDomain(cookieRoot);
    const rememberHours = parseFloat(modal.getAttribute('data-remember-hours')) || 336;
    const delay = parseInt(modal.getAttribute('data-delay'), 10) || 0;
    const closeButton = modal.querySelector('[id^="ModalClose-"]');

    log('Settings:', {
      cookieName: cookieName,
      cookieRoot: cookieRoot,
      resolvedCookieDomain: cookieDomain,
      rememberHours: rememberHours,
      delayMs: delay,
      currentHost: window.location.hostname,
      protocol: window.location.protocol,
      closeButtonFound: !!closeButton,
      designMode: !!(window.Shopify && window.Shopify.designMode),
    });

    function writeState(state) {
      return setCookie(cookieName, JSON.stringify(state), rememberHours, cookieDomain);
    }

    function recordDismissal() {
      log('Recording dismissal.');
      writeState({ status: 'dismissed', at: Date.now() });
    }

    function recordChoice(choice) {
      log('Recording choice:', choice);
      writeState({ status: 'chosen', choice: choice, at: Date.now() });
    }

    const existingState = readState(cookieName);

    if (existingState) {
      log('Existing cookie found - re-issuing it with the current "remember for" duration (' + rememberHours + 'hrs) so a settings change takes effect immediately.');
      writeState(existingState);
    }

    const choiceOptions = modal.querySelectorAll('[data-site-selector-choice]');
    log('Found', choiceOptions.length, 'option link(s) to wire up.');
    choiceOptions.forEach((option) => {
      option.addEventListener('click', (event) => {
        const href = option.getAttribute('href');
        log('Option clicked:', option.getAttribute('data-site-selector-choice'), 'href:', href);
        if (href) {
          event.preventDefault();
          recordChoice(option.getAttribute('data-site-selector-choice'));
          log('Redirecting to', href, 'after cookie write.');
          window.location.href = href;
        } else {
          recordChoice(option.getAttribute('data-site-selector-choice'));
        }
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', recordDismissal);
    } else {
      warn('No close button (id^="ModalClose-") found inside the modal - dismissal via the X will not be recorded.');
    }

    modal.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') recordDismissal();
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) recordDismissal();
    });

    if (window.Shopify && window.Shopify.designMode) {
      log('Theme editor design mode detected - showing immediately, ignoring cookie state.');
      modal.show();
      return;
    }

    if (existingState) {
      const reason = existingState.status === 'chosen' ? 'chose "' + existingState.choice + '"' : 'dismissed it';
      log('NOT showing popup: visitor already ' + reason + ' (cookie "' + cookieName + '" is still valid).');
      return;
    }

    log('No valid existing cookie - will show popup in', delay, 'ms.');
    window.setTimeout(() => {
      if (document.body.contains(modal)) {
        log('Showing popup now.');
        modal.show();
      } else {
        warn('Timer fired but modal is no longer in the document - not showing.');
      }
    }, delay);
  }

  function initAll() {
    const modals = document.querySelectorAll('.site-selector-popup');
    log('initAll() found', modals.length, 'element(s) with class "site-selector-popup".');
    if (modals.length === 0) {
      warn('No .site-selector-popup element found on the page - has the "Site selector popup" section been added to the header group?');
    }
    modals.forEach(init);
  }

  log('Script loaded. document.readyState =', document.readyState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    log('shopify:section:load fired for section', event.target.id || event.target);
    const modal = event.target.querySelector('.site-selector-popup');
    if (modal) init(modal);
  });
})();
